import { get } from 'app/utils/axios/kheti'
import { SectionInfo } from "../models/feed";

interface Response {
  sections: SectionInfo[];
}

const fetchFarmerFeeds = async () => {
  try {
    const url = `/farmer-360/v1/farmer/feeds`;
    return (await get<Response>(url)).sections;
  } catch (e) {
    return null;
  }
};

export default fetchFarmerFeeds;
